import React, { useState, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { fetchDistrictRanking } from '../../data/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const barColors = (values) => values.map(v => v >= 90 ? '#27ae60' : v >= 75 ? '#f39c12' : '#e74c3c');

const DDWHTop10Chart = () => {
  const [labels, setLabels] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    fetchDistrictRanking('desc', 10).then(r => {
      setLabels(r.data.map(d => d.n));
      setValues(r.data.map(d => parseFloat(d.avail)));
    }).catch(console.error);
  }, []);

  const data = {
    labels,
    datasets: [{
      label: 'Availability %', data: values,
      backgroundColor: barColors(values), borderRadius: 4,
      barPercentage: 0.6, categoryPercentage: 0.7
    }]
  };

  const options = {
    indexAxis: 'y', responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: { display: true, anchor: 'end', align: 'right', color: '#444', font: { weight: '700', size: 10 }, formatter: v => v + '%' }
    },
    scales: {
      x: { min: 80, max: 100, ticks: { font: { size: 10 }, callback: v => v + '%' }, grid: { color: '#f8fafc' } },
      y: { grid: { display: false }, ticks: { font: { size: 10 } } }
    }
  };

  return (
    <div className="chart-box">
      <h3>Stock Availability &mdash; Top 10 Districts</h3>
      <div style={{ position: 'relative', minHeight: '300px' }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default DDWHTop10Chart;
